import { Icon } from "@iconify/react";
import * as Utilities from "../Constants/Utilities";
import FunkerPlayer from "../Video/Player/FunkerPlayer";

export default function ListVideoPlayer({ topVideo }) {
  return (
    <div className="topVideoPlayer">
      <div className="topVideoPlayer__label">Your top result:</div>
      <FunkerPlayer video={topVideo} allwaysMuted={true} />
      <div className="topVideoPlayer__title moreReadable">
        <a href={`/video/${topVideo?.slug}`}>{topVideo?.title}</a>
        <div className="videoData">
          <div className="videoViews">
            <Icon icon="ion:eye" />
            {topVideo?.viewCount}
          </div>
          <div className="videoDate">
            {Utilities.GetPrettyDate(topVideo?.publicationDate)}
          </div>
        </div>
      </div>
    </div>
  );
}
